import { ButtonGroup } from "@/components/_atoms/button-group";
import { Label } from "@/components/_atoms/label";
import { NumberInput } from "@/components/_atoms/number-input";
import { Popover, PopoverPortalContent, PopoverTrigger } from "@/components/_atoms/popover";
import { QuickSearchInput } from "@/components/_molecules/quick-search-input";
import { ToolbarFilterButton } from "@/components/_molecules/toolbar-filter-button";
import { useDomainTranslation } from "@/domain/_shared/i18n/use-domain-translation";
import { MunicipalPropertyRegisterFilter } from "@/domain/municipal-property/models/municipal-property-register-filter.model";
import { buildDatatableToolbarRowClass } from "@/domain/view/components/datatable/datatable-toolbar-row-class";

const YEAR_INPUT_ID = "municipal-property-register-filter-year";

interface MunicipalPropertyRegisterFilterBarProps {
  filter: MunicipalPropertyRegisterFilter;
  onSearchChange: (search: string) => void;
  onYearChange: (year: number | null) => void;
}

export function MunicipalPropertyRegisterFilterBar({
  filter,
  onYearChange,
  onSearchChange,
}: MunicipalPropertyRegisterFilterBarProps) {
  const { t } = useDomainTranslation("municipal-property");

  return (
    <div className={buildDatatableToolbarRowClass(false)}>
      <ButtonGroup className="w-full min-w-0 flex-1">
        <QuickSearchInput value={filter.search ?? ""} onChange={onSearchChange} />
        <Popover>
          <PopoverTrigger asChild={true}>
            <ToolbarFilterButton />
          </PopoverTrigger>
          <PopoverPortalContent side="bottom" align="end" className="flex w-72 flex-col gap-3 p-3">
            <div className="flex flex-col gap-1.5">
              <Label htmlFor={YEAR_INPUT_ID}>{t("register.filter.year")}</Label>
              <NumberInput
                id={YEAR_INPUT_ID}
                className="h-8"
                value={filter.year}
                onValueChange={onYearChange}
                inputMode="numeric"
                placeholder={t("register.filter.yearPlaceholder")}
              />
            </div>
          </PopoverPortalContent>
        </Popover>
      </ButtonGroup>
    </div>
  );
}
